import React, { Component } from 'react'
import { Button, Input, Select, Tooltip } from 'antd'
import { inject, observer } from 'mobx-react'
import { commissions } from '@services/api'
import { alertPopup } from '@utils/popup'
import RateComp from '../RateComp'
import MathExpr, { op } from '../MathExpr'
import SubscriptionOptionLabel from '../SubscriptionOptionLabel'
import { historySubs } from '../historySubs'
import { missingMsg } from '../../utils'

@inject((store: any) => {
    const { authStore, popupStore, subscriptionsStore } = store

    return {
        authStore,
        popupStore,
        subscriptionsStore
    }
})
@observer
export default class DebtForm extends Component<any> {
    constructor(props) {
        super(props)
        this.state = {
            inValid: false,
            monthsToCharge: 12,
            lastCommission: '',
            reason: '',
            rate: 0,
            rateParent: 0,
            subscriptionList: []
        }
    }

    componentDidMount() {
        this.setLastCommission()
        this.setSubscriptionList()
    }

    resetReason = () => {
        this.setState({ reason: '' })
    }

    componentDidUpdate(prevProps) {
        const {
            info: { selectedClient, subscription }
        } = this.props

        if (prevProps.info.selectedClient && prevProps.info.selectedClient.client_id !== selectedClient.client_id) {
            this.resetReason()
            this.setLastCommission()
            this.setSubscriptionList()
            this.forceUpdate()
        }

        if (prevProps.info.recentClientSubscriptions && this.props.info.recentClientSubscriptions) {
            // rebuild whenever the sub count changes (covers data arriving after mount).
            // builtForLen stops it looping when historySubs returns [] for a non-empty list.
            const len = this.props.info.recentClientSubscriptions.length
            if (len > 0 && this.builtForLen !== len) {
                this.builtForLen = len
                this.setSubscriptionList()
            }
        }

        if (prevProps.info.subscription.id !== subscription.id) {
            this.setRate()
        }
    }

    setSubscriptionList = () => {
        const {
            info: { recentClientSubscriptions, selectedClient },
            selectSubscription
        } = this.props

        // use the subscription saved on the selected client's history
        let subscriptionList = historySubs(selectedClient, recentClientSubscriptions)

        // preselect the first matching subscription
        if (subscriptionList.length) selectSubscription(subscriptionList[0].select_id)

        this.setState({ subscriptionList })
    }

    onSubscriptionSelect = value => {
        const { selectSubscription } = this.props
        const { subscriptionList } = this.state

        if (typeof value == 'string' && value.includes('special_')) {
            value = value.split('_')[1]
            value = subscriptionList.find(({ user_subscription_id }) => user_subscription_id == value).id
        }
        // if (specialSub) {
        //     value = subscriptionList.find(({ user_subscription_id }) => user_subscription_id == value).id
        // }

        selectSubscription(value)
    }

    setRate = lastCommission => {
        const { productName, agentType, percents, clientSubscription, subscription } = this.props.info
        const { current_parent_percent, current_percent } = clientSubscription
        if (!lastCommission) lastCommission = this.state.lastCommission || {}

        if (productName) {
            let old = null
            let rate = 0
            let rateParent = 0
            let rateType = 'monthly'

            let monthlyPercent = JSON.parse(lastCommission.monthly_percent || '[]')

            if (monthlyPercent.length && lastCommission.payment_type == 'MONTHLY') {
                // what about old commissions with no monthly_percent ?? or are they to be added?
                rate = monthlyPercent.at(-1).percent
            } else if (lastCommission.payment_type == 'YEARLY') {
                rate = lastCommission.advanced_percent
            }

            if (!rate || lastCommission.user_subscription_id != subscription.user_subscription_id) {
                if (lastCommission.payment_type == 'MONTHLY') {
                    rateType = 'monthly'
                } else if (subscription.specialSub || lastCommission.payment_type == 'YEARLY') {
                    rateType = 'advanced'
                }

                if (percents[productName].older_than) {
                    if (
                        new Date(clientSubscription.paid_at).getTime() <
                        new Date(percents[productName].older_than).getTime()
                    ) {
                        old = true
                    }
                }

                rate = percents[productName][agentType][old ? 'old' : rateType]
            }

            if (current_percent) rate = current_percent
            if (agentType === 'sub' && current_parent_percent) rateParent = current_parent_percent

            this.setState({ rate, rateParent })
        }
    }

    handleRateInput = (e, key) => {
        this.setState({ [key]: e.target.value.replace(/[^0-9.]*((\d*\.?\d{0,9})).*/g, '$2') })
    }

    setLastCommission = () => {
        const {
            info: { clientCommissions }
        } = this.props

        if (clientCommissions) {
            const lastCommission = clientCommissions.commissions.find(
                ({ balance, one_time, user_subscription_id }) =>
                    balance === 'CREDIT' && (!one_time || user_subscription_id)
            )

            this.setRate(lastCommission)
            this.setState({
                monthsToCharge: lastCommission ? lastCommission.numerator || lastCommission.advanced_months || 1 : 1, // was: 12,
                lastCommission: lastCommission
            })
        }
    }

    setMonthsToCharge = monthsToCharge => {
        this.setState({ monthsToCharge })
    }

    setReason = reason => {
        this.setState({ reason })
    }

    submit = e => {
        e.preventDefault()
        const {
            info,
            info: { agentInfo, selectedClient, subscription }
        } = this.props
        const { reason, monthsToCharge, rate, rateParent } = this.state

        let missing = []

        let payload = {
            agent_id: agentInfo.id,
            client_id: selectedClient.client_id,
            balance: 'DEBT',
            cancellation_reason: reason,
            months_to_charge: subscription.specialSub ? 1 : monthsToCharge,
            subscription_id: subscription.id,
            user_subscription_id: subscription.user_subscription_id,
            current_percent: rate,
            current_parent_percent: rateParent
        }

        let nodeNames = {
            TEXTAREA: 'TEXTAREA',
            INPUT: 'INPUT'
        }

        let fields = {
            clientAmount: 'amount',
            comment: 'comment'
        }

        for (let el in e.target.elements) {
            let target = e.target.elements[el]

            if (nodeNames[target.nodeName] && target.id.includes('input')) {
                let field = fields[target.id.split('-')[1]]
                payload[field] = target.value

                if (field) {
                    if (!target.value) {
                        missing.push(field == 'amount' ? 'סכום' : 'הערה')
                        target.style.border = 'solid red 1px'
                    } else {
                        target.style.border = 'solid #d9d9d9 1px'
                    }
                }
            }
        }

        if (!reason) {
            missing.push('סיבת חיוב')
        }

        if (missing.length) {
            this.setState({ inValid: true })
            const msg = missingMsg(missing)
            alertPopup({ type: 'error', title: msg, body: '' })
            return
        }

        commissions
            .createNewCommission(payload)
            .then(() => {
                this.props.getAgentCommissions()
                this.props.getAgentCommissionTotals()
                // this.props.onClose()
                // alert('עמלה נוצרה בהצלחה')
                this.props.resetFormData()

                const body = (
                    <Button
                        onClick={() => {
                            this.props.popupStore.togglePopup('mentorDebtCommission', {
                                agentInfo,
                                clientAgentInfo: info
                            })
                        }}
                    >
                        {'ליצירת עמלת מנטור'}
                    </Button>
                )
                alertPopup({ type: 'success', title: 'עמלה נוצרה בהצלחה', body })
            })
            .catch(err => {
                console.log(err)
                alertPopup({ type: 'error', title: 'הפעולה נכשלה', body: '' })
            })
    }

    cancellationReasons = {
        NOT_INTERSTED: 'לקוח לא מעוניין',
        COMPETITORS: 'מתחרים',
        DOUBLE_SUBSCRIPTION: 'כפל מנויים',
        DENIAL_TRANSACTION: 'הכחשת עסקה',
        STO_CANCELLED: 'ביטול הוראת קבע',
        RETURNED_CHARGE: 'חיוב חוזר',
        BLOCKING_PAYMENT_METHOD: 'חסימת אמצעי תשלום',
        EXPENSIVE_PRICE: 'מחיר יקר',
        BAD_SERVICE: 'חווית שירות לא טובה',
        NOT_USED: 'לא השתמש בשירות',
        UPGRADE: 'שדרוג מינוי',
        CHANGE_SUBSCRIPTION: 'שינוי מינוי',
        OTHER: 'אחר'
    }

    render() {
        const {
            info: {
                clientAmount,
                subscription,
                // commissionRate,
                clientCommissions,
                clientSubscription,
                percents,
                agentType,
                productName
            },
            selectSubscription,
            handleFormInput,
            subscriptionsStore: { subscriptions }
        } = this.props

        const { monthsToCharge, rate: commissionRate, subscriptionList, rateParent } = this.state

        // let monthlyRate = 0
        // let advancedRate = 0

        // let old = null
        // let commissionRate = 0
        // if (productName) {

        //     if (percents[productName].older_than) {
        //         if (new Date(clientSubscription.paid_at).getTime() < new Date(percents[productName].older_than).getTime()) {
        //             old = true
        //         }
        //     }
        //     commissionRate = percents[productName][agentType][old ? 'old' : (monthsToCharge > 1 ? 'advanced' : 'monthly')]
        // }

        const agentAmount = subscription.specialSub
            ? clientAmount * commissionRate
            : clientAmount * commissionRate * monthsToCharge

        let activeCreditCommission
        if (clientCommissions) {
            activeCreditCommission = !!clientCommissions.commissions.find(
                ({ balance, status }) => balance === 'CREDIT' && status === 'ACTIVE'
            )
        }

        let activeDebtCommission
        if (clientCommissions) {
            activeDebtCommission = !!clientCommissions.commissions.find(
                ({ balance, status }) => balance === 'DEBT' && status === 'ACTIVE'
            )
        }

        return (
            <>
                {activeCreditCommission && !activeDebtCommission && (
                    <h6 style={{ alignSelf: 'center', color: '#fd7200' }}>קיים זיכוי פעיל עבור לקוח זה</h6>
                )}
                {activeDebtCommission && !activeCreditCommission && (
                    <h6 style={{ alignSelf: 'center', color: '#fd7200' }}>קיים חיוב פעיל עבור לקוח זה</h6>
                )}
                {activeCreditCommission && activeDebtCommission && (
                    <h6 style={{ alignSelf: 'center', color: '#fd7200' }}>קיימות עמלות פעילות ללקוח זה</h6>
                )}
                <form onSubmit={this.submit} style={{ ...style.column, ...style.form }}>
                    <div style={{ ...style.formLine }}>
                        <span>מינוי:</span>
                        <Select
                            className="commission-select"
                            // value={subscription && subscription.id}
                            // value={subscription && subscription.specialSub ? subscription.user_subscription_id : subscription.id}
                            value={subscription ? subscription.select_id : ''}
                            onChange={selectSubscription}
                            // onChange={(value) => this.onSubscriptionSelect(value)}
                            dropdownClassName="commission-dropdown"
                            style={{ width: '70%' }}
                            dropdownMatchSelectWidth={false}
                        >
                            {subscriptionList.map((sub, index) => {
                                const format = str => {
                                    return new Date(str).toLocaleDateString('he-IL').replace(/\./g, '/')
                                }

                                let start, end
                                if (sub.dates_range) {
                                    let parsed = JSON.parse(sub.dates_range || '{}')
                                    start = format(parsed.start)
                                    end = format(parsed.end)
                                }

                                if (sub.id > 30)
                                    // return <Select.Option style={{ paddingInline: '0' }} title={sub.name} value={sub.specialSub ? `special_${sub.user_subscription_id}` : sub.id} key={index.toString() + 'a'}>
                                    return (
                                        <Select.Option
                                            style={{ paddingInline: '10px' }}
                                            title={sub.name}
                                            value={sub.select_id}
                                            key={index.toString() + 'a'}
                                        >
                                            <SubscriptionOptionLabel
                                                name={sub.name}
                                                subscription_status={sub.subscription_status}
                                                paid_at={sub.paid_at}
                                                extra={
                                                    sub.specialSub ? (
                                                        <span
                                                            style={{
                                                                whiteSpace: 'nowrap',
                                                                color: '#888',
                                                                fontSize: '12px'
                                                            }}
                                                        >
                                                            {start} - {end}
                                                        </span>
                                                    ) : null
                                                }
                                            />
                                        </Select.Option>
                                    )
                            })}
                        </Select>
                    </div>

                    <div style={{ ...style.formLine }}>
                        <span>{`מחיר מינוי (חודשי)`}</span>
                        <Input
                            value={clientAmount}
                            id="input-clientAmount"
                            onChange={handleFormInput}
                            style={{ ...style.inputStyle }}
                        />
                    </div>

                    <div style={{ ...style.formLine, minHeight: '37px' }}>
                        {subscription.specialSub ? (
                            ''
                        ) : (
                            <>
                                <span>מספר חודשים לחיוב</span>
                                <Select
                                    className="commission-select"
                                    dropdownClassName="commission-dropdown"
                                    value={monthsToCharge}
                                    onChange={this.setMonthsToCharge}
                                    style={{ width: '70%' }}
                                    dropdownStyle={{ textAlign: 'right' }}
                                >
                                    {new Array(30).fill(null).map((_, index) => {
                                        return (
                                            <Select.Option
                                                key={index.toString()}
                                                style={{ textAlign: 'right' }}
                                                value={index + 1}
                                            >
                                                {index + 1}
                                            </Select.Option>
                                        )
                                    })}
                                </Select>
                            </>
                        )}
                    </div>

                    <Tooltip
                        title={
                            <MathExpr
                                tokens={[
                                    { value: clientAmount },
                                    op('×'),
                                    { value: commissionRate },
                                    ...(subscription.specialSub ? [] : [op('×'), { value: monthsToCharge }])
                                ]}
                            />
                        }
                    >
                        <div style={{ ...style.formLine }}>
                            <span>{`סכום לחיוב סוכן`}</span>
                            <div style={{ width: '70%', ...style.column }}>
                                <input
                                    id="input-agentAmount"
                                    value={agentAmount.toFixed(1).replace(/\.?0*$/, '')}
                                    disabled
                                    style={{ border: 'none', background: 'none' }}
                                />
                                <RateComp
                                    rate={commissionRate}
                                    title={'לפי שיעור:'}
                                    keys={'rate'}
                                    handle={this.handleRateInput}
                                />
                                {agentType === 'sub' ? (
                                    <div style={{ marginTop: '10px' }}>
                                        <RateComp
                                            rate={rateParent}
                                            title={'שיעור אחוז אב:'}
                                            keys={'rateParent'}
                                            handle={this.handleRateInput}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Tooltip>

                    <div style={{ ...style.formLine }}>
                        <span>סיבת חיוב</span>
                        <Select
                            className="commission-select"
                            dropdownClassName="commission-dropdown"
                            value={this.state.reason}
                            style={{ ...style.inputStyle, textAlign: 'right' }}
                            dropdownStyle={{ textAlign: 'right' }}
                            onChange={this.setReason}
                        >
                            {Object.keys(this.cancellationReasons).map((reason, index) => (
                                <Select.Option value={reason} key={index.toString()} style={{ textAlign: 'right' }}>
                                    {this.cancellationReasons[reason] || ''}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>

                    {this.state.reason === 'OTHER' && (
                        <div style={{ ...style.formLine }}>
                            <span>פירוט</span>
                            <Input.TextArea
                                id="input-comment"
                                rows={3}
                                maxLength={250}
                                style={{ ...style.inputStyle }}
                            />
                        </div>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button style={{ ...style.button }}>אישור</button>
                    </div>
                </form>
            </>
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    form: { width: '100%', margin: '0 0 30px 0' },
    line1: { display: 'flex', justifyContent: 'end' },
    formLine: { display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '15px' },
    inputStyle: { width: '70%' },
    button: {
        height: '34px',
        width: '64px',
        background: 'white',
        borderRadius: '4px',
        border: 'solid #d9d9d9 1px',
        cursor: 'pointer',
        margin: '0 10px'
    }
}
